import { useEffect, useMemo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SyncIcon from '@mui/icons-material/Sync';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { useDeviceManagementCapability } from '../../hooks';
import { useSyncStoreConfigurationModal } from '../../hooks/useSyncConfigurationStoreModal.hook';
import { withDeviceManagementContainer } from '../../utils/withDeviceManagementContainer.util';
import type {
  ExposedSyncConfigurationModalProps,
  SyncConfigurationModalState,
} from '../../model/syncConfigurationModal.model';

export function ExposedSyncConfigurationStoreModalComponent({
  onStateChange,
  id: storeId,
}: ExposedSyncConfigurationModalProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.STORE, ALL_LNGS_NAMESPACES.COMMON]);
  const canMsSyncConfiguration = useDeviceManagementCapability('logicalDevice.msSyncConfiguration');
  const { handleOpenModal, modalComponent } = useSyncStoreConfigurationModal();

  const menuOption = useMemo<SyncConfigurationModalState['menuOption']>(() => {
    return canMsSyncConfiguration
      ? {
          icon: <SyncIcon />,
          label: t('button.syncConfig'),
          onClick: () => handleOpenModal(storeId),
          dataTestId: 'btn-sync-configuration-store',
        }
      : undefined;
  }, [canMsSyncConfiguration, handleOpenModal, t, storeId]);

  const state = useMemo<SyncConfigurationModalState>(() => ({ menuOption }), [menuOption]);

  useEffect(() => {
    onStateChange(state);
  }, [onStateChange, state]);

  return modalComponent;
}

export const ExposedSyncConfigurationStoreModal = withDeviceManagementContainer(
  ExposedSyncConfigurationStoreModalComponent,
);
